import { render, staticRenderFns } from "./PosterModule.vue?vue&type=template&id=2f92b7c4&scoped=true&"
import script from "./PosterModule.vue?vue&type=script&lang=js&"
export * from "./PosterModule.vue?vue&type=script&lang=js&"
import style0 from "./PosterModule.vue?vue&type=style&index=0&id=2f92b7c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92b7c4",
  null
  
)

export default component.exports